import { FaJs, FaPython, FaHtml5, FaDatabase } from 'react-icons/fa';

const Skills = () => (
  <>
  <h2 className="text-2xl font-semibold border-b-2 border-blue-500 dark:border-blue-300 pb-2 mb-4">Technical Skills</h2>
 <div className="w-full  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4  p-6 rounded-lg">
      <div className=" backdrop-blur-sm dark:bg-opacity-25  dark:bg-gray-700 p-4 rounded-lg shadow-2xl flex flex-col items-center text-center">
        <FaJs className="text-4xl text-yellow-500 mb-2" />
        <h3 className="text-xl font-semibold">JavaScript</h3>
        <p>Experienced in ES6+, Node.js, and frameworks like React and Express.</p>
      </div>
      <div className=" backdrop-blur-sm dark:bg-opacity-25  dark:bg-gray-700 p-4 rounded-lg shadow-2xl flex flex-col items-center text-center">
        <FaPython className="text-4xl text-blue-700 mb-2" />
        <h3 className="text-xl font-semibold">Python</h3>
        <p>Skilled in Django, Flask, and data analysis libraries.</p>
      </div>
      <div className=" backdrop-blur-sm dark:bg-opacity-25  dark:bg-gray-700 p-4 rounded-lg shadow-2xl flex flex-col items-center text-center">
        <FaHtml5 className="text-4xl text-orange-500 mb-2" />
        <h3 className="text-xl font-semibold">HTML & CSS</h3>
        <p>Proficient in responsive design, Tailwind CSS, and custom styling.</p>
      </div>
      <div className=" backdrop-blur-sm dark:bg-opacity-25  dark:bg-gray-700 p-4 rounded-lg shadow-2xl flex flex-col items-center text-center">
        <FaDatabase className="text-4xl text-green-500 mb-2" />
        <h3 className="text-xl font-semibold">Database Management</h3>
        <p>Experienced with SQL and NoSQL databases like PostgreSQL and MongoDB.</p>
      </div>
    </div>
    </>

);

export default Skills;
